import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './components/app/app.component';
import { BodyComponent } from './components/body/body.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CalculatorModule } from './modules/calculator/calculator.module';
import { HeaderModule } from './modules/header/header.module';
import { AlertDialogComponent } from './components/dialogs/alert-dialog/alert-dialog.component';
import { MatButtonModule, MatCardModule, MatExpansionModule, MatDialogModule, MatAccordion } from '@angular/material';
import { EdgeDialogComponent } from './components/dialogs/edge-dialog/edge-dialog.component';
import { MatSliderModule } from '@angular/material/slider';
import { YourSavingsComponent } from './components/your-savings/your-savings.component';
import { WindowsContainerComponent } from './components/windows-container/windows-container.component';

@NgModule({
  declarations: [
    AppComponent,
    BodyComponent,
    AlertDialogComponent,
    EdgeDialogComponent,
    WindowsContainerComponent,
    // YourSavingsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule,
    HttpClientModule,
    CalculatorModule,
    HeaderModule, 
    MatButtonModule,
    MatCardModule,
    MatExpansionModule,
    MatDialogModule,
    MatSliderModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [
    AlertDialogComponent,
    EdgeDialogComponent,
    YourSavingsComponent
  ]
})
export class AppModule { }
